import React from 'react';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';

interface InfoRowProps {
    label: string;
    value: string | number | React.ReactNode;
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const content = [
        <Typography
            key="value"
            sx={{
                fontFamily: 'Lato, sans-serif',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '120%',
                letterSpacing: '-0.2px',
                color: theme.palette.text.primary
            }}
        >
            {value}
        </Typography>,
        <Typography
            key="label"
            sx={{
                fontFamily: 'Lato, sans-serif',
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '120%',
                letterSpacing: '-0.2px',
                color: theme.palette.text.secondary,
                mt: 0.5
            }}
        >
            {label}
        </Typography>
    ];

    return (
        <Grid container spacing={1} sx={{ py: 1 }}>
            <Grid item xs={12}>
                <Box>{content}</Box>
            </Grid>
            {isMobile && (
                <Box
                    sx={{
                        width: '100%',
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        mt: 1
                    }}
                />
            )}
        </Grid>
    );
};
